import { render, staticRenderFns } from "./CalendarData.vue?vue&type=template&id=5c5c70ce&scoped=true"
import script from "./CalendarData.vue?vue&type=script&lang=js"
export * from "./CalendarData.vue?vue&type=script&lang=js"
import style0 from "./CalendarData.vue?vue&type=style&index=0&id=5c5c70ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c70ce",
  null
  
)

export default component.exports